import { As, Text, TextProps } from '@chakra-ui/react';
import React, { FC } from 'react';
import is from 'is';

type TypographyProps = TextProps;

export const Typography: FC<TypographyProps> = ({ variant = 'p', children, ...rest }) => {
  /**
   * DOM
   */
  const textProps: TypographyProps = {
    ...rest,
  };
  if (is.string(variant) && ['h0', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(variant as string)) {
    textProps.as = variant as As;
  }
  return (
    <Text data-object-type="typography" {...textProps}>
      {children}
    </Text>
  );
};
